import styled from "styled-components";
import { Anchor, Button } from "discover.medical.react-component-library";

export const SpecialtyItemWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  padding: ${({ theme }) => theme.space.sm} 0;
  display: inline-block;
  width: 100%;
`;
export const SpecialtyLinkAnchor = styled(Anchor)`
  width: 70%;
`;
export const SpecialtyFollowButton = styled(Button)`
  justify-content: left;
  width: 30%;
  vertical-align: top;
`;

export const SpecialtiesTable = styled.div`
  margin-top: ${({ theme }) => theme.space.sm};
  padding: 0 ${({ theme }) => theme.space.sm};
  column-count: 3;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    column-count: 2;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    column-count: 1;
  }
`;
